import Vue from 'vue';
import marked from 'marked';
import highlightjs from 'highlight.js';
import firebase from '@/services/firebaseConfig';
import 'firebase/firestore';

const db = firebase.firestore();

// initialize marked
const {
  Renderer,
} = marked;
const renderer = new Renderer();
renderer.code = (code, language) => {
  // Check whether the given language is valid for highlight.js.
  const validLang = !!(language && highlightjs.getLanguage(language));
  // Highlight only if the language is valid.
  const highlighted = validLang ? highlightjs.highlight(language, code).value : code;
  // Render the highlighted code with `hljs` class.
  return `<pre><code class="hljs ${language}">${highlighted}</code></pre>`;
};

marked.setOptions({
  gfm: true,
  breaks: true,
  renderer,
});

function preparePost(doc) {
  const post = doc.data();
  post.id = doc.id;
  post.html = marked(post.text);
  return post;
}

const service = new Vue({
  data: {
    allPosts: [],
    pagePosts: [],
    currentPage: 0,
  },
  methods: {
    setPage() {
      // start from: if 1, then 1 -1 = 0, 0 * 10 = 0
      // start from: if 2, then 1 - 2 = 1, 1 * 10 = 10
      // to: if 1, then 0 + 10 = 10 (last taken item is 9)
      // tp: if 2, then 10 + 10 = 20 (last taken item is 19)
      this.allPosts.sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));

      this.pagePosts = this.allPosts
        .slice((this.currentPage - 1) * 10, ((this.currentPage - 1) * 10) + 10);

      this.$emit('loadPage', this.pagePosts);
    },
    loadPage(page) {
      this.currentPage = page;
      if (this.allPosts.length === 0) {
        db.collection('posts').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const post = preparePost(doc);
            this.allPosts.push(post);
          });
          this.setPage();
        }).catch();
      } else {
        this.setPage();
      }
    },
    getPost(id) {
      const localPost = this.allPosts.find(p => p.id === id);
      if (localPost) {
        this.$emit('getPost', localPost);
      } else {
        db.collection('posts').doc(id).get().then((doc) => {
          if (doc.exists) {
            const post = preparePost(doc);
            this.$emit('getPost', post);
          }
        });
      }
    },
    savePost(post) {
      const newPost = post;
      newPost.created_at = (new Date()).toISOString();
      newPost.markdown = true;

      db.collection('posts').add(newPost)
        .then(() => {
          this.$emit('savePost');
        })
        .catch(() => {
          this.$emit('savePost');
        });
      this.allPosts = [];
      this.pagePosts = [];
    },
    updatePost(post) {
      const updatedPost = {
        text: post.text,
        title: post.title,
        edited_at: (new Date()).toISOString(),
        markdown: true,
      };
      db.collection('posts').doc(post.id).set(updatedPost, {
        merge: true,
      })
        .then(() => {
          this.$emit('updatePost');
        })
        .catch(() => {
          this.$emit('updatePost');
        });
      this.allPosts = [];
      this.pagePosts = [];
    },
    deletePost(id) {
      db.collection('posts').doc(id).delete()
        .then(() => {
          this.$emit('deletePost');
        })
        .catch(() => {
          this.$emit('deletePost');
        });
      this.allPosts = [];
      this.pagePosts = [];
    },
  },
});

export default service;
